import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '../languages/en.json'
import vi from '../languages/vi.json'

Vue.use(VueI18n)

const i18nMessages = { en, vi }
const language = window.localStorage.getItem('language') ? window.localStorage.getItem('language') : 'en'
const i18n = new VueI18n({ locale: language, messages: i18nMessages })
export default i18n
